import { jsx } from 'react/jsx-runtime';
import 'luxon';
import { useMemo } from 'react';
import 'styled-components';
import '../../../theme/GlobalStyle.js';
import 'react-helmet-async';
import _ from 'lodash';
import '../../../theme/ThemedComponentWrapper.js';
import '../../icons/ActivityIcon.js';
import '../../icons/ArrowDownIcon.js';
import '../../icons/ArrowDownRightCircleIcon.js';
import '../../icons/ArrowLeftAlignIcon.js';
import '../../icons/ArrowLeftIcon.js';
import '../../icons/ArrowRightAlignIcon.js';
import '../../icons/ArrowRightIcon.js';
import '../../icons/ArrowSwitchIcon.js';
import '../../icons/ArrowUpIcon.js';
import '../../icons/ArrowUpRightCircleIcon.js';
import '../../icons/ArrowsAngleExpandIcon.js';
import '../../icons/BankIcon.js';
import '../../icons/CheckIcon.js';
import '../../icons/ChevronDownIcon.js';
import '../../icons/ChevronRightIcon.js';
import '../../icons/ChevronUpIcon.js';
import '../../icons/CopyIcon.js';
import '../../icons/CrossIcon.js';
import '../../icons/DaiIcon.js';
import '../../icons/DangerIcon.js';
import '../../icons/DownSortIcon.js';
import '../../icons/ExclamationTriangleIcon.js';
import '../../icons/ExpandKpiIcon.js';
import '../../icons/EyeIcon.js';
import '../../icons/EyeSlashIcon.js';
import '../../icons/Grid1x2Icon.js';
import '../../icons/InfoCircleIcon.js';
import '../../icons/ListIcon.js';
import '../../icons/LockIcon.js';
import '../../icons/MediumIcon.js';
import '../../icons/MoonIcon.js';
import '../../icons/PiggyBankIcon.js';
import '../../icons/QuestionMarkCircleIcon.js';
import '../../icons/ShieldIcon.js';
import '../../icons/SunIcon.js';
import '../../icons/UpSortIcon.js';
import '../../icons/XIcon.js';
import '../../atoms/Input/Input.js';
import '../../atoms/ToggleSwitch.js';
import '../../atoms/Table/Table.js';
import '../../atoms/Table/components/HeaderCell/HeaderCell.js';
import '@floating-ui/react';
import '../../atoms/Tooltip/components/TooltipContext.js';
import '../../atoms/Tooltip/components/TooltipContent.js';
import '../../atoms/Tooltip/components/TooltipTrigger.js';
import '../../atoms/Table/components/Pagination/Pagination.js';
import '../../atoms/layout/Stack/Stack.js';
import 'ethereum-blockies-base64';
import '../../molecules/CurrencyValue/components/Value.js';
import '../../pictograms/EthPictogram.js';
import '../../pictograms/EtherScanPictogram.js';
import '../../pictograms/DebankPictogram.js';
import '../../pictograms/ZapperPictogram.js';
import '../../pictograms/DaiPictogram.js';
import '../../molecules/TrendValue.js';
import '../../molecules/KpiCard/KpiCard.js';
import '../../molecules/Tabs/Tabs.js';
import EmptyBox from '../../molecules/EmptyBox.js';
import SimpleChart from '../SimpleChart.js';
import '../ChartKpis/ChartKpi.js';
import '../ChartJS.js';
import '../Heatmap/Heatmap.js';
import 'randomcolor';
import 'd3';
import '../../XRay.js';

function LineChart({ data, datasets, config, ...rest }) {
    const mergedConfig = useMemo(() => {
        const defaultConfig = {
            type: 'line',
            options: {
                fill: true,
                elements: {
                    line: {
                        borderWidth: 2
                    }
                }
            }
        };
        return _.merge(defaultConfig, config);
    }, [config]);
    if (datasets) {
        return (jsx(SimpleChart, { data: data, datasets: datasets, config: mergedConfig, ...rest }));
    }
    return jsx(EmptyBox, {});
}

export { LineChart as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGluZUNoYXJ0LmpzIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9jaGFydHMvTGluZUNoYXJ0L0xpbmVDaGFydC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRW1wdHlCb3ggfSBmcm9tICdAaW5kZXgnO1xuaW1wb3J0IF8gZnJvbSAnbG9kYXNoJztcbmltcG9ydCB7IHVzZU1lbW8gfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgU2ltcGxlQ2hhcnQsIHsgU2ltcGxlQ2hhcnRQcm9wcyB9IGZyb20gJy4uL1NpbXBsZUNoYXJ0JztcblxuZXhwb3J0IGludGVyZmFjZSBMaW5lQ2hhcnRQcm9wcyBleHRlbmRzIFNpbXBsZUNoYXJ0UHJvcHMge31cblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gTGluZUNoYXJ0KHtcbiAgZGF0YSxcbiAgZGF0YXNldHMsXG4gIGNvbmZpZyxcbiAgLi4ucmVzdFxufTogTGluZUNoYXJ0UHJvcHMpIHtcbiAgY29uc3QgbWVyZ2VkQ29uZmlnID0gdXNlTWVtbygoKSA9PiB7XG4gICAgY29uc3QgZGVmYXVsdENvbmZpZyA9IHtcbiAgICAgIHR5cGU6ICdsaW5lJyxcbiAgICAgIG9wdGlvbnM6IHtcbiAgICAgICAgZmlsbDogdHJ1ZSxcbiAgICAgICAgZWxlbWVudHM6IHtcbiAgICAgICAgICBsaW5lOiB7XG4gICAgICAgICAgICBib3JkZXJXaWR0aDogMlxuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH07XG5cbiAgICByZXR1cm4gXy5tZXJnZShkZWZhdWx0Q29uZmlnLCBjb25maWcpO1xuICB9LCBbY29uZmlnXSk7XG5cbiAgaWYgKGRhdGFzZXRzKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIDxTaW1wbGVDaGFydFxuICAgICAgICBkYXRhPXtkYXRhfVxuICAgICAgICBkYXRhc2V0cz17ZGF0YXNldHN9XG4gICAgICAgIGNvbmZpZz17bWVyZ2VkQ29uZmlnfVxuICAgICAgICB7Li4ucmVzdH1cbiAgICAgIC8+XG4gICAgKTtcbiAgfVxuXG4gIHJldHVybiA8RW1wdHlCb3ggLz47XG59XG4iXSwibmFtZXMiOlsiX2pzeCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFPd0IsU0FBQSxTQUFTLENBQUMsRUFDaEMsSUFBSSxFQUNKLFFBQVEsRUFDUixNQUFNLEVBQ04sR0FBRyxJQUFJLEVBQ1EsRUFBQTtBQUNmLElBQUEsTUFBTSxZQUFZLEdBQUcsT0FBTyxDQUFDLE1BQUs7QUFDaEMsUUFBQSxNQUFNLGFBQWEsR0FBRztBQUNwQixZQUFBLElBQUksRUFBRSxNQUFNO0FBQ1osWUFBQSxPQUFPLEVBQUU7QUFDUCxnQkFBQSxJQUFJLEVBQUUsSUFBSTtBQUNWLGdCQUFBLFFBQVEsRUFBRTtBQUNSLG9CQUFBLElBQUksRUFBRTtBQUNKLHdCQUFBLFdBQVcsRUFBRSxDQUFDO0FBQ2YscUJBQUE7QUFDRixpQkFBQTtBQUNGLGFBQUE7U0FDRixDQUFDO1FBRUYsT0FBTyxDQUFDLENBQUMsS0FBSyxDQUFDLGFBQWEsRUFBRSxNQUFNLENBQUMsQ0FBQztBQUN4QyxLQUFDLEVBQUUsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDO0lBRWIsSUFBSSxRQUFRLEVBQUU7QUFDWixRQUFBLFFBQ0VBLEdBQUMsQ0FBQSxXQUFXLElBQ1YsSUFBSSxFQUFFLElBQUksRUFDVixRQUFRLEVBQUUsUUFBUSxFQUNsQixNQUFNLEVBQUUsWUFBWSxLQUNoQixJQUFJLEVBQUEsQ0FDUixFQUNGO0tBQ0g7SUFFRCxPQUFPQSxHQUFBLENBQUMsUUFBUSxFQUFBLEVBQUEsQ0FBRyxDQUFDO0FBQ3RCOzs7OyJ9
